import { Loading3QuartersOutlined } from '@ant-design/icons'
import { Empty, Table as TableAnt, TableProps } from 'antd'
import { t } from 'i18next'

const Table = (props: TableProps<any>) => {
  const { loading, ...resProp } = props
  const antIcon = <Loading3QuartersOutlined style={{ fontSize: 30 }} spin />
  return (
    <TableAnt
      loading={{ indicator: antIcon, spinning: !!loading }}
      locale={{
        emptyText: (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={t('not-found-data')}
          />
        )
      }}
      {...resProp}
    />
  )
}

export default Table
